<template>
  <div
    class="m-not-allowed-cover"
    v-if="notAllowed"
  >
    <div class="m-tip-wrap">
      <div>
        <span>{{$t('common.browser_no_allowed')}}</span>
        <span>{{$t('common.browser_recommend')}}</span>
      </div>
    </div>
  </div>
  <div
    class="browser-judge"
    v-else
  >
    {{$t('common.browser_warn_tips')}}
    <i
      class="u-btn-close h-icon-close"
      @click="handleClose"
    ></i>
  </div>
</template>

<script>
import config from 'api/config'
export default {
  data () {
    return {
      notAllowed: false,
      warn: false
    }
  },
  mounted () {
    this.judgeBrowser()
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    // 判断浏览器
    judgeBrowser () {
      let agent = navigator.userAgent.toLowerCase()
      let regStrChrome = /chrome\/[\d.]+/gi
      let regStrFirefox = /firefox\/[\d.]+/gi
      const isIE11 = agent.indexOf('trident') > -1 && agent.indexOf('rv:11.0') > -1
      const isChrome = agent.indexOf('chrome') > 0
      const isFirefox = agent.indexOf('firefox') > 0
      const chromeV = isChrome ? parseInt((agent.match(regStrChrome) + '').replace(/[^0-9.]/ig, '')) : 0
      const FireFoxV = isFirefox ? parseInt((agent.match(regStrFirefox) + '').replace(/[^0-9.]/ig, '')) : 0
      if (isIE11 || chromeV >= config.chromeVersion) {
        this.warn = false
        this.notAllowed = false
        this.handleClose()
      } else if ((isChrome && chromeV < config.chromeVersion) || (isFirefox && FireFoxV >= config.Firefox)) {
        this.warn = true
        this.notAllowed = false
      } else {
        this.warn = false
        this.notAllowed = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.browser-judge {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 32px;
  color: #4d4d4d;
  font-size: 12px;
  line-height: 32px;
  text-align: center;
  background-color: #fc0;
  z-index: 999;
  .u-btn-close {
    display: block;
    float: right;
    font-size: 16px;
    margin: 8px;
    cursor: pointer;
  }
}
.m-not-allowed-cover {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background: rgb(238, 238, 238);
  .m-tip-wrap {
    position: absolute;
    display: table-column;
    left: 50%;
    margin-left: -240px;
    top: 50%;
    margin-top: -100px;
    background: #fff;
    border-radius: 4px;
    div {
      display: table-cell;
      width: 480px;
      height: 200px;
      vertical-align: middle;
      text-align: center;
      span {
        display: block;
        color: #4d4d4d;
      }
      span:first-child {
        font-size: 22px;
        font-weight: bold;
        line-height: 40px;
      }
    }
  }
}
</style>
